import ViewPadrao from "../views/ViewPadrao";
import OrdemMedicaoList from "../views/OrdemMedicaoList";
import OrdemMedicaoCad from "../views/OrdemMedicaoCad";
import OrdemMedicaoItem from "../views/OrdemMedicaoItem";
import OrdemMedicaoFaturar from "../views/OrdemMedicaoFaturar";
import OrdemMedicaoNfs from "../views/OrdemMedicaoNfs";

export default {
  path: "ordem-medicao",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "ordem-medicao-list",
      component: OrdemMedicaoList,
    },
    {
      path: "novo",
      name: "ordem-medicao-formulario",
      component: OrdemMedicaoCad,
    },
    {
      path: "editar/:id",
      name: "ordem-medicao-formulario-editar",
      component: OrdemMedicaoCad,
    },
    {
      path: "item/:id",
      name: "ordem-medicao-cadastro-item",
      component: OrdemMedicaoItem,
    },
    {
      path: "faturar/:id",
      name: "ordem-medicao-faturar",
      component: OrdemMedicaoFaturar,
    },
    {
      path: "nfs/:id",
      name: "ordem-medicao-nfs",
      component: OrdemMedicaoNfs,
    },
  ],
};
